module.exports = __webpack_public_path__ + "img/eletroduto2.907f6f6e.png";